"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UndrawWarning = exports.UndrawVoid = exports.UndrawUnavailable = exports.UndrawThrowAway = exports.UndrawSecureLogin = exports.UndrawNoData = exports.UndrawEmpty = exports.UndrawDataProcessing = exports.UndrawAddFiles = void 0;
var UndrawAddFiles_1 = __importDefault(require("./UndrawAddFiles"));
var UndrawDataProcessing_1 = __importDefault(require("./UndrawDataProcessing"));
var UndrawEmpty_1 = __importDefault(require("./UndrawEmpty"));
var UndrawNoData_1 = __importDefault(require("./UndrawNoData"));
var UndrawSecureLogin_1 = __importDefault(require("./UndrawSecureLogin"));
var UndrawThrowAway_1 = __importDefault(require("./UndrawThrowAway"));
var UndrawUnavailable_1 = __importDefault(require("./UndrawUnavailable"));
var UndrawVoid_1 = __importDefault(require("./UndrawVoid"));
var UndrawWarning_1 = __importDefault(require("./UndrawWarning"));
var UndrawAddFiles_2 = require("./UndrawAddFiles");
Object.defineProperty(exports, "UndrawAddFiles", { enumerable: true, get: function () { return __importDefault(UndrawAddFiles_2).default; } });
var UndrawDataProcessing_2 = require("./UndrawDataProcessing");
Object.defineProperty(exports, "UndrawDataProcessing", { enumerable: true, get: function () { return __importDefault(UndrawDataProcessing_2).default; } });
var UndrawEmpty_2 = require("./UndrawEmpty");
Object.defineProperty(exports, "UndrawEmpty", { enumerable: true, get: function () { return __importDefault(UndrawEmpty_2).default; } });
var UndrawNoData_2 = require("./UndrawNoData");
Object.defineProperty(exports, "UndrawNoData", { enumerable: true, get: function () { return __importDefault(UndrawNoData_2).default; } });
var UndrawSecureLogin_2 = require("./UndrawSecureLogin");
Object.defineProperty(exports, "UndrawSecureLogin", { enumerable: true, get: function () { return __importDefault(UndrawSecureLogin_2).default; } });
var UndrawThrowAway_2 = require("./UndrawThrowAway");
Object.defineProperty(exports, "UndrawThrowAway", { enumerable: true, get: function () { return __importDefault(UndrawThrowAway_2).default; } });
var UndrawUnavailable_2 = require("./UndrawUnavailable");
Object.defineProperty(exports, "UndrawUnavailable", { enumerable: true, get: function () { return __importDefault(UndrawUnavailable_2).default; } });
var UndrawVoid_2 = require("./UndrawVoid");
Object.defineProperty(exports, "UndrawVoid", { enumerable: true, get: function () { return __importDefault(UndrawVoid_2).default; } });
var UndrawWarning_2 = require("./UndrawWarning");
Object.defineProperty(exports, "UndrawWarning", { enumerable: true, get: function () { return __importDefault(UndrawWarning_2).default; } });
exports.default = {
    'add-files': UndrawAddFiles_1.default,
    'data-processing': UndrawDataProcessing_1.default,
    'empty': UndrawEmpty_1.default,
    'no-data': UndrawNoData_1.default,
    'secure-login': UndrawSecureLogin_1.default,
    'throw-away': UndrawThrowAway_1.default,
    'unavailable': UndrawUnavailable_1.default,
    'void': UndrawVoid_1.default,
    'warning': UndrawWarning_1.default,
};
